/**
 * This file is a browser-specific entry point for logging.
 * We differentiate between browser and Node environments
 * to account for differences in the underlying pino API and
 * configuration.
 *
 * Some pino features are exclusive to browser environments
 * and vice versa. Configuration varies between the two. We
 * provide a shim for isomorphic usage.
 *
 * Pino browser API
 * https://getpino.io/#/docs/browser
 *
 * Browser package field spec
 * https://github.com/defunctzombie/package-browser-field-spec
 *
 * Webpack exports guide
 * https://webpack.js.org/guides/package-exports/
 */

import { Logger } from './lib/logger/Logger.browser';

export default Logger;
export * from './lib/types';
